import React, { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { IUser } from '@users/user/vo/User';

interface IProps {
  children: React.ReactNode,
  user: IUser | undefined,
}

const SentryUserData = ({
  children,
  user,
}: IProps) => {
  useEffect(() => {
    if (user?.id) {
      Sentry.setUser({ id: user.id });
    }
    return () => {
      Sentry.setUser(null);
    };
  }, [user?.id]);

  return children;
};

export default SentryUserData;
